export const fluegeltore_data =
    {
        category: 'Flügeltor',
        modell: [
            {
                index: '',
                kind: 'Flügeltor',
                img: '',
                titel: '',
                form: '',
                muster: '',
                price: 1550
            }
        ],
        tab_index: 0,
        data_description: [
            {
                image: '',
                file: '',
                own_modell_file: '',
                own_modell_image: '',
                description: '',
                isUploadData: false
            }
        ],
        steps: [
            [[false], [false], [false], [false], [false], [false]],
            {
             visited: [0],
             active_steps: []
            }
        ],
        form: '',
        dimensions: [
            {
            width: '',
            height: '',
          },
        ],
        colors: [
            {
                kind_of_color: '',
                wish_color: '',
                color_index: '',
                color: '',
            }
        ],
        spitzen: [
            {
                spitze: '',
                index: ''
            }
        ],
        pfosten: [
            {
                ispfosten: false,
                iskappen: false,
                pfosten_width: '',
                kappe: '',
                kappe_index: ''
            }
        ],
        antrieb: '',
        direction: '',
        allVisitedSteps: false,
        is_merkliste: false
    }